<template >
  <v-dialog
    transition="scroll-x-transition"
    overlay-color="grey darken-2"
    content-class="ec-confirmation-dialog"
    :width="textBig ? 440 :300"
    v-model="confirmDialog"
    persistent
  >
    <v-card color="accent" :width="textBig ? 440 :300">
      <v-card-title dark style="background-color:#47BD96;color:white">
          {{title}}
      </v-card-title>
      <v-card-text class="pb-0 pt-5 text-center">
        <p class="pt-1 ec-dialog-text" style>{{text}}</p>

        <p v-if="text2.length" class="ec-dialog-text red--text" color="red" style>{{text2}}</p>
      </v-card-text>
      <v-card-actions class="pt-0">
        <v-spacer></v-spacer>
        <v-btn text @click="$emit('confirmation-event', false)">{{cancelButton}}</v-btn>
        <v-btn
          :color="cantDelete ? 'red':'primary'"
          text
          @click="$emit('confirmation-event', true)"
        >{{acceptButton}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  computed: {
    textBig() {
      return this.text.length > 30;
    },
    confirmDialog: {
      get() {
        return this.dialog;
      },
      set(value) {
        this.$emit("mutate-confirm-dialog", value);
      },
    },
  },
  props: {
    dialog: {
      default: false,
      type: Boolean,
    },
    text: {
      default: "",
      type: String,
    },
    text2: {
      default: "",
      type: String,
    },
    acceptButton: {
      default: "Ok",
      type: String,
    },
    cancelButton: {
      default: "Cancel",
      type: String,
    },
    title: {
      default: "Delete",
      type: String,
    },
    cantDelete: {
      default: false,
      type: Boolean,
    },
  },
  mounted(){
    let parentScope = this
    document.body.onkeydown = function (ev) {
      if(parentScope.confirmDialog && ev.keyCode === 13 && ev.which === 13) {
        parentScope.$emit('confirmation-event', true)
      }
    };
  },
};
</script>
<style>
.ec-confirmation-dialog {
  box-shadow: none !important;
  overflow-y: hidden;
}
.ec-confirmation-dialog .v-card {
  background: #000000;
}
.ec-pageTitle {
  color: #fff;
  font-family: Dosis,sans-serif;
  font-size: 22px;
  font-weight: 700;
  letter-spacing: 2.11px;
  text-transform: uppercase;
}
</style>
<style scoped>
.theme--dark .ec-dialog-text {
  color: whitesmoke;
}
.theme--light .ec-dialog-text {
  color: rgb(0, 0, 0, 0.85);
}
.ec-dialog-text {
  font-family: "Roboto", sans-serif;
  line-height: 1.5;
  font-weight: 400;
  font-size: 16px;
  text-align: center;
}
</style>